import { Box } from '@mui/material'
import React from 'react'
import ModalHeader from '../../Components/Modal/ModalHeader'

type Props = {}

const Helper = (props: Props) => {
  return (
    <Box>
      
    </Box>
  )
}

export default Helper